export const envURL = process.env.REACT_APP_BASE_URL;
export const baseURL = envURL?.toString();
